import PropTypes from 'prop-types';
import Badge from './Badge';

export default function JobTile({ job, taxonomies }) {
	const { title, permalink, excerpt } = job;

	return (
		<a className="tile" href={permalink}>
			<div className="tile__container">
				<header className="tile__header">
					<p className="h6" dangerouslySetInnerHTML={{ __html: title }}></p>
				</header>
				<p className="tile__content">{excerpt} ...</p>
				<footer className="tile__footer">
					<div className="tile__badges">
						{Object.values(job.taxonomies.work_experience).map((slug) => {
							const location = taxonomies.work_experience.terms.filter((term) => term.slug === slug);
							return <Badge key={slug} name={location[0]?.name} />;
						})}
					</div>
				</footer>
			</div>
		</a>
	);
}

JobTile.propTypes = {
	job: PropTypes.object,
	taxonomies: PropTypes.object,
};
